// duplicated import of gesture handler is required for bottom sheet modal to work on android
/* eslint-disable import/no-duplicates */
// FIXME: see how why did you render works
// import './wdyr'
import 'react-native-gesture-handler'
import 'react-native-reanimated'
import '~i18n'

import { ENABLE_MOCKED_SERVER, USING_REACTOTRON } from '~constants'
import { useAppStateActive } from '~hooks'
import { Navigation } from '~navigation'
import { Providers } from '~providers'
import { startMockedServer, readFromStorageCacheQuery } from '~services'
import { checkForUpdates } from '~utils'

// if (__DEV__ && USING_REACTOTRON && !process.env.JEST_WORKER_ID) {
//   import('./ReactotronConfig').then(() => console.log('Reactotron Configured'))
// }

if (ENABLE_MOCKED_SERVER) {
  startMockedServer()
}
readFromStorageCacheQuery()

const App = (): JSX.Element => {
  useAppStateActive(checkForUpdates)
  return (
    <Providers>
      <Navigation />
    </Providers>
  )
}

export default App
